var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.45614 2.79379C5.24109 0.0088413 9.75638 0.0088413 12.5413 2.79379C15.3263 5.57874 15.3263 10.094 12.5413 12.879L11.5692 13.8404C10.8527 14.5437 9.92299 15.4478 8.77979 16.5531C8.06542 17.2438 6.93206 17.2437 6.2178 16.5529L3.35858 13.7717C2.99923 13.4188 2.69843 13.1213 2.45614 12.879C-0.328805 10.094 -0.328805 5.57874 2.45614 2.79379ZM11.6726 3.66247C9.36746 1.35729 5.63001 1.35729 3.32483 3.66247C1.01964 5.96766 1.01964 9.7051 3.32483 12.0103L4.54275 13.2121C5.21343 13.8685 6.05656 14.6879 7.07186 15.6698C7.30995 15.9001 7.68774 15.9001 7.92586 15.6699L10.7063 12.966C11.0904 12.589 11.4125 12.2704 11.6726 12.0103C13.9778 9.7051 13.9778 5.96766 11.6726 3.66247ZM7.49873 5.60351C8.8564 5.60351 9.95701 6.70412 9.95701 8.06179C9.95701 9.41946 8.8564 10.5201 7.49873 10.5201C6.14106 10.5201 5.04045 9.41946 5.04045 8.06179C5.04045 6.70412 6.14106 5.60351 7.49873 5.60351ZM7.49873 6.83201C6.81955 6.83201 6.26896 7.3826 6.26896 8.06179C6.26896 8.74097 6.81955 9.29156 7.49873 9.29156C8.17792 9.29156 8.72851 8.74097 8.72851 8.06179C8.72851 7.3826 8.17792 6.83201 7.49873 6.83201Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.8c30fee3893ae9fd92b122e936ab02b3.svg";
export { ForwardRef as ReactComponent };